//-----------------------------------------------
// Login
//-----------------------------------------------

function initLoginForm() {
    const loginForm = document.querySelector('.login');
    if (!loginForm) return;
    const formWrap = loginForm.querySelector('.login__form-wrap');
    const passwordField = loginForm.querySelector('.login__password-field');
    const errorContainer = loginForm.querySelector('.login__form-error');

    //get the current url
    const url = new URL(window.location.href);
    //keep only the url without the path or parameters
    const urlPath = url.origin;
    console.log(url + ' ' + urlPath);


    function loginFormSubmit(e) {
        const el = e.target;
        e.preventDefault();
        const form = el;
        const password = passwordField.value;
        let error = false;
        errorContainer.innerHTML = '';


        // passwordField.removeAttribute('placeholder');
        passwordField.setAttribute('placeholder', '');

        if (password.length < 1) {
            error = 'Incorrect password';
        }

        if (error) {
            errorContainer.classList.add('active');
            errorContainer.append(document.createTextNode(error));
            passwordField.focus();
            return;
        }

        checkAccess(password);
    }

    function passwordInput(e) {
        errorContainer.classList.remove('active');
    }

    function checkAccess(access) {
        const data = {
            action: 'ajax_check_access',
            access: access,
        }

        jQuery.ajax({
            url: php_data.custom_ajaxurl,
            async: true,
            cache: true,
            data: data,
            error: function (jqXHR, textStatus) {
                console.log("Status: " + jqXHR.status);
                console.log("textStatus: " + textStatus);

                error = 'Incorrect password';
                if (error) {
                    errorContainer.classList.add('active');
                    errorContainer.append(document.createTextNode(error));
                    passwordField.focus();

                    return;
                }

            },
            success: function (response) {
                var result = JSON.parse(response);
                if (result.access === true && result.token) {
                    window.location.href = urlPath + '?access=' + result.token;
                } else {
                    errorContainer.classList.add('active');
                    errorContainer.append(document.createTextNode(result.error));
                    passwordField.focus();
                }
            }
        });
    }

    loginForm.addEventListener('submit', loginFormSubmit, false);

    passwordField.addEventListener('mousedown', passwordInput, false);
}

// initLoginForm();

//-----------------------------------------------
// Accounts
//-----------------------------------------------

var createAccountControls = document.querySelectorAll('.accounts__add-button');

if (createAccountControls.length > 0) {
    var createAccountModal = document.querySelector('.account-create');
    var createAccountForm = createAccountModal.querySelector('#account-create');
    var createAccountFormWrap = createAccountForm.parentNode;
    var createAccountFormInputs = createAccountForm.querySelectorAll('input');
    var nameFieldId = 'client_name';
    var accessFieldId = 'access_code';
    var durationFieldId = 'duration';
    var galleryFieldId = 'gallery';
    var errorValues = {
        'empty': {
            'client_name': 'Client Name is required',
            'access_code': 'Access Code is required',
            'duration': 'Duration (days) is required',
            'gallery': 'Invalid Gallery',
        }
    }

    function openCreateAccountModal(e) {
        createAccountModal.classList.add('active');
        e.target.blur();
        setTimeout(function () {
            var randomNum = Math.floor(Math.random() * 10000000);
            document.getElementById(accessFieldId).value = randomNum;
            document.getElementById(nameFieldId).focus();
        }, 300);
    }

    function closeCreateAccountModal(e) {
        e.stopPropagation();
        if (e.target.closest('.account-create__form-wrap')) return;
        createAccountModal.classList.remove('active');
        createAccountResetValidation();
    }

    function submitCreateAccountForm(e) {
        e.preventDefault();
        var name = document.getElementById(nameFieldId);
        var nameField = name.parentNode;
        var nameFieldValidation = nameField.querySelector('.account-create__form-field-validation');
        var access = document.getElementById(accessFieldId);
        var accessField = access.parentNode;
        var accessFieldValidation = accessField.querySelector('.account-create__form-field-validation');
        var duration = document.getElementById(durationFieldId);
        var durationField = duration.parentNode;
        var durationFieldValidation = durationField.querySelector('.account-create__form-field-validation');
        var gallery = document.getElementById(galleryFieldId);
        var galleryField = gallery.parentNode;
        var galleryFieldValidation = galleryField.querySelector('.account-create__form-field-validation');
        var galleryFieldValidOptions = ['Standard', 'Extended'];

        var submitButton = createAccountForm.querySelector('.account-create__form-submit');
        submitButton.blur();

        var nameIsValid = accessIsValid = durationIsValid = galleryIsValid = false;

        if (name.value.length < 1) {
            nameField.classList.add('invalid');
            nameFieldValidation.textContent = errorValues.empty[nameFieldId];
        } else {
            nameField.classList.remove('invalid');
            nameFieldValidation.textContent = '';
            nameIsValid = true;
        }
        if (access.value.length < 1) {
            accessField.classList.add('invalid');
            accessFieldValidation.textContent = errorValues.empty[accessFieldId];
        } else {
            accessField.classList.remove('invalid');
            accessFieldValidation.textContent = '';
            accessIsValid = true;
        }
        if (duration.value.length < 1) {
            durationField.classList.add('invalid');
            durationFieldValidation.textContent = errorValues.empty[durationFieldId];
        } else {
            durationField.classList.remove('invalid');
            durationFieldValidation.textContent = '';
            durationIsValid = true;
        }
        if (gallery.value.length < 1 || !galleryFieldValidOptions.includes(gallery.value)) {
            galleryField.classList.add('invalid');
            galleryFieldValidation.textContent = errorValues.empty[galleryFieldId];
        } else {
            galleryField.classList.remove('invalid');
            galleryFieldValidation.textContent = '';
            galleryIsValid = true;
        }

        if (!nameIsValid || !accessIsValid || !durationIsValid || !galleryIsValid) return;

        // Make for inactive
        createAccountModal.classList.add('inactive');

        var data = {
            action: 'ajax_create_account',
            name: name.value,
            access: access.value,
            duration: duration.value,
            gallery: gallery.value,
        }

        jQuery.ajax({
            url: php_data.custom_ajaxurl,
            async: true,
            cache: true,
            data: data,
            error: function (jqXHR, textStatus) {
                console.log("Status: " + jqXHR.status);
                console.log("textStatus: " + textStatus);
            },
            success: function (response) {
                // console.log(response);
                var result = JSON.parse(response);
                if (result.access_error) {
                    accessField.classList.add('invalid');
                    access.focus();
                    accessFieldValidation.textContent = result.access_error;
                    createAccountModal.classList.remove('inactive');
                } else {
                    createAccountModal.classList.remove('active');
                    updateAccountTable(result);
                    setTimeout(function () {
                        createAccountModal.classList.remove('inactive');
                        name.value = '';
                        access.value = '';
                        duration.value = '';
                    }, 300);
                }
            }
        });
    }

    function updateAccountTable(result) {
        if (result.account_id) {
            var data = {
                action: 'ajax_get_account_table_row',
                account: result.account_id,
            }

            jQuery.ajax({
                url: php_data.custom_ajaxurl,
                async: true,
                cache: true,
                data: data,
                error: function (jqXHR, textStatus) {
                    console.log("Status: " + jqXHR.status);
                    console.log("textStatus: " + textStatus);
                },
                success: function (response) {
                    if (response) {
                        var tableBody = document.querySelector('.accounts-table__table tbody');
                        var noAccountsRow = tableBody.querySelector('.accounts-table__no-accounts');
                        if (noAccountsRow) {
                            noAccountsRow.remove();
                        }
                        tableBody.innerHTML = tableBody.innerHTML + response;
                        var row = tableBody.querySelector('[data-account-id="' + result.account_id + '"]');
                        setTimeout(function () {
                            row.classList.remove('ajaxed');
                        }, 2500);
                    }
                }
            });
        }
    }

    function createAccountInputBlur(e) {
        var field = e.target.parentNode;
        var fieldId = e.target.getAttribute('id');
        var validation = field.querySelector('.account-create__form-field-validation');
        if (e.target.value.length < 1) {
            field.classList.add('invalid');
            validation.textContent = errorValues.empty[fieldId];
        } else {
            field.classList.remove('invalid');
            validation.textContent = '';
        }
    }

    function createAccountResetValidation() {
        createAccountFormInputs.forEach(function (e, i) {
            var field = e.parentNode;
            var fieldId = field.id
            var validation = field.querySelector('.account-create__form-field-validation');
            field.classList.remove('invalid');
            validation.textContent = '';
        });
    }

    function copyAccountAccessUrl(e) {
        var el = e.target;
        var control = el.closest('.accounts-table__table-copy');
        if (!control || !control.classList.contains('accounts-table__table-copy')) return;
        var inner = control.parentNode;
        var url = inner.querySelector('.accounts-table__table-account-url-link').getAttribute('href');
        var copied = copyToClipboard(url);
        if (copied) {
            var msg = inner.querySelector('.accounts-table__table-copy-copied');
            msg.classList.add('active');
            setTimeout(function () {
                msg.classList.remove('active');
            }, 1000);
        }
    }

    function incrementAccountDuration(e) {
        var el = e.target;
        if (!el.classList.contains('accounts-table__increment-duration')) return;
        el.disabled = true;
        var row = el.closest('tr');
        var dur = row.querySelector('.accounts-table__duration');
        var time_remaining = row.querySelector('.accounts-table__time-remaining');
        var account_id = row.getAttribute('data-account-id');
        var data = {
            action: 'ajax_update_account_duration',
            account: account_id,
        }

        jQuery.ajax({
            url: php_data.custom_ajaxurl,
            async: true,
            cache: true,
            data: data,
            error: function (jqXHR, textStatus) {
                console.log("Status: " + jqXHR.status);
                console.log("textStatus: " + textStatus);
            },
            success: function (response) {
                var result = JSON.parse(response);
                if (result.duration) {
                    dur.classList.add('inactive');
                }
                if (result.time_remaining) {
                    time_remaining.classList.add('inactive');
                }
                setTimeout(function () {
                    if (result.duration) {
                        dur.innerHTML = result.duration;
                    }
                    if (result.time_remaining) {
                        time_remaining.textContent = result.time_remaining;
                    }
                    dur.classList.remove('inactive');
                    time_remaining.classList.remove('inactive');
                }, 250);
                setTimeout(function () {
                    e.target.disabled = false;
                }, 350);
            }
        });
    }

    function deleteAccount(e) {
        var el = e.target;
        if (!el.classList.contains('accounts-table__account-controls-delete')) return;
        el.disabled = true;
        var row = el.closest('tr');
        var cells = row.querySelectorAll('td');
        var account_id = row.getAttribute('data-account-id');
        var data = {
            action: 'ajax_delete_account',
            account: account_id,
        }
        jQuery.ajax({
            url: php_data.custom_ajaxurl,
            async: true,
            cache: true,
            data: data,
            error: function (jqXHR, textStatus) {
                console.log("Status: " + jqXHR.status);
                console.log("textStatus: " + textStatus);
            },
            success: function (response) {
                var result = JSON.parse(response);
                if (result.deleted) {
                    row.classList.add('deleted');
                    var rowHeight = row.offsetHeight + 'px';
                    cells.forEach(function (cell, i) {
                        cell.style.opacity = 0;
                    });
                    setTimeout(function () {
                        cells.forEach(function (cell, i) {
                            cell.remove();
                        });
                        row.innerHTML = '<td height="' + rowHeight + '" colspan="9"></td>';
                    }, 300);
                    setTimeout(function () {
                        var newCell = row.querySelector('td');
                        newCell.style.height = 0;
                        newCell.style.padding = 0;
                    }, 600);
                    setTimeout(function () {
                        row.remove();
                    }, 900);
                }
            }
        });
    }

    function pauseUnpauseAccount(e) {
        var el = e.target;
        if (!el.classList.contains('accounts-table__account-controls-suspend')) return;
        el.disabled = true;
        var row = el.closest('tr');
        var account_id = row.getAttribute('data-account-id');
        var account_action = el.getAttribute('data-action');
        var status = row.querySelector('.accounts-table__status');
        var access_date = row.querySelector('.accounts-table__access-date');
        var access = access_date === 'Waiting for client' ? false : true;
        var data = {
            action: 'ajax_pause_unpause_account',
            account: account_id,
            account_action: account_action,
            access: access,
        }
        jQuery.ajax({
            url: php_data.custom_ajaxurl,
            async: true,
            cache: true,
            data: data,
            error: function (jqXHR, textStatus) {
                console.log("Status: " + jqXHR.status);
                console.log("textStatus: " + textStatus);
            },
            success: function (response) {
                var result = JSON.parse(response);
                if (result.status) {
                    if (result.status === 'Suspended') {
                        el.setAttribute('data-action', 'unsuspend');
                    } else if (result.status === 'Ready' || result.status === 'Active') {
                        el.setAttribute('data-action', 'suspend')
                    }
                    status.textContent = result.status;
                    el.disabled = false;
                }
            }
        });
    }

    // Event handler for opening modal
    createAccountControls.forEach(function (e, i) {
        e.addEventListener('click', openCreateAccountModal, false);
    });

    // Event handlers for closing modal
    createAccountModal.addEventListener('click', closeCreateAccountModal, false);
    document.querySelector('.account-create__modal-close').addEventListener('click', function () {
        createAccountResetValidation();
        createAccountModal.classList.remove('active');
    }, false);

    // Event handler for form submit
    createAccountForm.addEventListener('submit', submitCreateAccountForm, false);

    // Event handler for form input blurs
    createAccountFormInputs.forEach(function (e, i) {
        e.addEventListener('blur', createAccountInputBlur, false);
    });

    // Event handler for copy url buttons
    document.addEventListener('click', copyAccountAccessUrl, false);

    // Event handler for increment duration buttons
    document.addEventListener('click', incrementAccountDuration, false);

    // Event handler for delete buttons
    document.addEventListener('click', deleteAccount, false);

    // Event handler for pause/unpause buttons
    document.addEventListener('click', pauseUnpauseAccount, false);
}


//-----------------------------------------------
// Clipboard Copying
//-----------------------------------------------

// Copies a string to the clipboard. Must be called from within an
// event handler such as click. May return false if it failed, but
// this is not always possible. Browser support for Chrome 43+,
// Firefox 42+, Safari 10+, Edge and Internet Explorer 10+.
// Internet Explorer: The clipboard feature may be disabled by
// an administrator. By default a prompt is shown the first
// time the clipboard is used (per session).
function copyToClipboard(text) {
    if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return clipboardData.setData("Text", text);
    } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand("copy");  // Security exception may be thrown by some browsers.
        } catch (ex) {
            console.warn("Copy to clipboard failed.", ex);
            return false;
        } finally {
            document.body.removeChild(textarea);
        }
    }
}
